




























































import { Component, Prop, Vue } from "vue-property-decorator";
import { GameConfigType, GameType, PlayerType, PlayersType } from "@/types";
import Constraints from "@/app/engine/constraints/Constraints";
import Engine from "@/app/engine/Engine";
import GalleryList from "@/components/game/GalleryList.vue";
import PlayerList from "@/components/game/PlayerList.vue";
import TopicsList from "@/components/game/TopicsList.vue";
import { pluralize } from "@/app/helpers";

@Component({ components: { GalleryList, PlayerList, TopicsList } })
export default class Voting extends Vue {
  @Prop({ required: true }) config!: GameConfigType;
  @Prop({ required: true }) game!: GameType;
  @Prop({ required: true }) isOwner!: boolean;
  @Prop({ required: true }) player!: PlayerType;
  @Prop({ required: true }) players!: PlayersType;

  imposterCount = Engine.imposterCount(Object.keys(this.players).length);
  votes: string[] = [];

  get buttonText() {
    return `Submit ${pluralize("Vote", this.imposterCount)} for ${this.imposterCount} ${pluralize(
      "Imposter",
      this.imposterCount
    )}`;
  }
  get constraint() {
    return Constraints.from(this.game.constraint);
  }
  get sortedResponses() {
    return Object.keys(this.game.responses)
      .sort((a: string, b: string) => {
        return this.game.responses[a].time > this.game.responses[b].time ? 1 : -1;
      })
      .map((k) => ({ playerId: k, value: this.game.responses[k].value }));
  }

  get topics() {
    return this.game.topics.slice(0, 2);
  }

  get valid() {
    return this.votes.length === this.imposterCount;
  }

  submitVote(e: Event) {
    e.preventDefault();
    if (this.valid)
      this.$root.$data.store.gameUpdate({
        votes: { [this.player.id]: { time: Date.now(), value: this.votes } },
      });
  }

  toggleVote(id: string) {
    if (this.votes.includes(id)) return this.votes.splice(this.votes.indexOf(id), 1);
    else if (this.valid) this.votes.shift();
    this.votes.push(id);
  }
}
